import React, { createContext, useState, useEffect } from "react";
import { BASE_URL } from "../config/config";
import axios from "axios";

export const BusinessSettingsContext = createContext();

export const BusinessSettingsProvider = ({ children }) => {
    const [settings, setSettings] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios.get(`${BASE_URL}/business-settings`)
            .then(response => {
                console.log("API Response:", response.data); // Debugging step
                const settingsData = {};
                response.data.forEach(item => {
                    settingsData[item.key] = item.value;
                });
                setSettings(settingsData);
            })
            .catch(error => {
                console.error("Error fetching business settings:", error);
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    return (
        <BusinessSettingsContext.Provider value={{ settings, loading }}>
            {children}
        </BusinessSettingsContext.Provider>
    );
};
